import { CircularProgress, Grid, Typography, Stack } from "@mui/material";
import login from "../../Image/Logo1.png";
import Logo_Medical from "../../Image/Logo.png";
import Logo_Provider from "../../Image/Logo_Provider.png";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import MoonLoader from "react-spinners/MoonLoader";
import Logo_HealthID from "../../Image/Logo_HealthID.png";
import { APIEndpoint } from "../../client/apiconfig"; // นำเข้า BASE_URL จาก apiConfig
import { BasicAuthUser } from "../../client/basicAuth";

const Login: React.FC = (): JSX.Element => {
  const history = useHistory();
  const [isLoading, setLoadingState] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      // Check for the user data in localStorage
      let params = new URLSearchParams(document.location.search);
      let error = params.get("error");
      // console.log("error", error)
      if (error === "401") {
        window.history.replaceState(null, "", window.location.pathname);
        Swal.fire({
          html: "<h2>การเข้าใช้งานระบบถูกปฏิเสธ<br>กรุณาเข้าสู่ระบบใหม่อีกครั้ง</h2>",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
            icon: "custom-swal-icon",
            actions: "custom-swal-actions",
          },
        });
      }

      // /?error=401
      // setCheckPage234(page)
    };
    fetchData();
  }, []);

  const setLoading = (state: boolean) => {
    setLoadingState(state);
  };

  // Alert Component
  const showErrorAlert = (text: string) => {
    Swal.fire({
      title: "เกิดข้อผิดพลาดในการเข้าสู่ระบบ",
      text: text,
      icon: "error",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = "/";
      }
    });
  };

  const sendCodeToBackend = async (code: string, tokenType: string) => {
    
    try {
      // Todo Set loading state -> true
      setLoading(true);
      // Todo Create body and header request for Login API

      const loginBodyReq = {
        code: code,
        redirect_uri: APIEndpoint.NavigationLogin,
        // redirect_uri: "http://localhost:3000/",
        token_type: tokenType,
      };

      const loginHeadyReq = {
        headers: {
          "Content-Type": "application/json",
        },
        // auth: BasicAuthUser,
        auth: BasicAuthUser,
      };
      // console.log("tokenType", tokenType)
      // console.log("code", code)

      // return false
      // Todo Call Login API to get user data
      var response = await axios.post(
        APIEndpoint.Login,
        loginBodyReq,
        loginHeadyReq
      );
      // Todo Prevent wrong enter way to the website
      if (response.status !== 200) {
        // Inform user that error occurred and Set loading state -> false
        // console.log("Status code: ", response.status);
        throw new Error("ข้อมูลการเข้าสู่ระบบไม่ถูกต้อง");
      }
      // Todo Save user data to localStorage for use as Select Agency Page.
      response.data.result.token_type = tokenType;
      sessionStorage.setItem("Data", JSON.stringify(response.data));

      // Todo Set loading state -> false
      setLoading(false);

      // Todo: Check if token_type == provider_id -> Redirect to Select Agency Page
      if (tokenType === "provider_id") {
        history.push("/select-agency");
      } else if (tokenType === "health_id") {
        // Todo: **Call API Register HealthID Data to Backend**

        // Then, Route to Personal Document Page.
        history.push("/pending-document");
      } else {
        // Todo Inform user that error occurred and Set loading state -> false
        throw new Error("ข้อมูลการเข้าสู่ระบบไม่ถูกต้อง");
      }
    } catch (error) {
      // Todo Inform user that error occurred and Set loading state -> false
      setLoading(false);
      showErrorAlert("กรุณาลองเข้าสู่ระบบใหม่อีกครั้ง");
      // Todo Remove it when deploy on production !!!
      console.error("Error occurred:", error);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    // Get code and token_type from URL
    const code = urlParams.get("code");
    const tokenType = urlParams.get("token_type");

    // เพิ่มการตรวจสอบก่อนดำเนินการ
    if (code && tokenType) {
      sendCodeToBackend(code, tokenType);
    } else {
      console.error("Necessary query params are not found from URL!!");
      // คุณสามารถทำการ redirect หรือแสดงข้อความแสดงข้อผิดพลาดที่นี่
    }

    // log code
    // console.log("login code: ", code);
    // console.log("login token_type: ", tokenType);
    // eslint-disable-next-line
  }, []);

  const handleNavigation = (tokenType: string) => {
    const redirectUri = encodeURIComponent(
      APIEndpoint.NavigationLogin
      // "http://localhost:3000/"
    );
    // Client ID Secret
    // const clientId = "19c6eed8-7445-4850-90be-6753634df94c";

    // uat
    const clientId = "9cdafe34-f9b8-4c5b-9450-c99fa127c4a5";

    //prd
    // const clientId = "9cdaff3f-9376-4b25-8629-47584bbe2a68";

    // uat
    const mophLoginUrl = `https://uat-moph.id.th/oauth/redirect?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&token_type=${tokenType}`;

    //prd
    // const mophLoginUrl = `https://pentest-moph.id.th/oauth/redirect?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&token_type=${tokenType}`;

    window.location.href = mophLoginUrl;
    // * Full path here
    // https://uat-moph.id.th/oauth/redirect?client_id=9cdafe34-f9b8-4c5b-9450-c99fa127c4a5&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2F&response_type=code
  };

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
          }}
        >
          <MoonLoader color="#ffffff" size={60} speedMultiplier={0.8} />
        </Box>
      ) : (
        <Grid container justifyContent="center">
          <Grid
            item
            xs={12}
            md={6} // ไอแพดหรือหน้าจอกลาง
            lg={6} // คอมพิวเตอร์
            sx={{
              backgroundColor: "#ffffff",
              mt: { xs: 10, sm: 18, md: 20, lg: 18 }, // ระยะห่างด้านบนที่แตกต่างกัน
              minHeight: { xs: "40vh", md: "60vh" }, // ปรับความสูงของคอนเทนต์ตามขนาดหน้าจอ
              borderRadius: {
                xs: "20px 20px 0 0",
                md: "20px 0 0 20px",
                lg: "20px 0 0 20px",
              }, // ปรับ border radius ให้เหมาะสมกับอุปกรณ์
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img srcSet={login} loading="lazy" width={300} />
          </Grid>

          <Grid
            item
            xs={12}
            md={6} // ไอแพด
            lg={5} // คอมพิวเตอร์
            sx={{
              backgroundColor: "#eef9ff",
              mt: { xs: 0, sm: 0, md: 20, lg: 18 }, // ระยะห่างด้านบนที่แตกต่างกัน
              minHeight: { xs: "40vh", md: "60vh" }, // ความสูงที่เหมาะสม
              borderRadius: {
                xs: "0 0 20px 20px",
                md: "0 20px 20px 0",
                lg: "0 20px 20px 0",
              }, // ปรับ radius ของ box ให้เหมาะสมกับหน้าจอ
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 2, md: 4 }, // เพิ่ม padding สำหรับมือถือ
            }}
          >
            <Box sx={{ mb: 3 }}>
              {" "}
              {/* เพิ่ม margin-bottom เพื่อเว้นระยะ */}
              <img srcSet={Logo_Medical} loading="lazy" width={150} />
            </Box>
            <Stack spacing={1} alignItems="center">
              <Button
                onClick={() => handleNavigation("provider_id")}
                variant="contained"
                sx={{
                  bgcolor: "#ffffff",
                  border: "1px solid #0D47A1",
                  borderRadius: "20px",
                  width: { xs: "220px", md: "250px" },
                  "&:hover": {
                    bgcolor: "#f5f5f5",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "10px", md: "12px" },
                    display: "flex",
                    alignItems: "center",
                    color: "#0D47A1",
                  }}
                >
                  เข้าสู่ระบบด้วยบัญชี
                  <Box sx={{ ml: 1 }}>
                    <img srcSet={Logo_Provider} loading="lazy" width={50} />
                  </Box>
                  ของคุณ
                </Typography>
              </Button>
              <Box sx={{ mb: 1 }}> </Box>
              <Button
                onClick={() => handleNavigation("health_id")}
                variant="contained"
                sx={{
                  bgcolor: "#0D47A1",
                  borderRadius: "20px",
                  width: { xs: "220px", md: "250px" },
                  "&:hover": {
                    bgcolor: "#0D47A1",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "10px", md: "12px" },
                    display: "flex",
                    alignItems: "center",
                    color: "#ffffff",
                  }}
                >
                  เข้าสู่ระบบด้วยบัญชี
                  <Box sx={{ ml: 1 }}>
                    <img srcSet={Logo_HealthID} loading="lazy" width={50} />
                  </Box>
                  ของคุณ
                </Typography>
              </Button>
            </Stack>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Login;
